/**
 * Okta Configuration for direct SPA auth.
 * Values injected via VITE_OKTA_* environment variables at build time.
 */

export const oktaConfig = {
  issuer: import.meta.env.VITE_OKTA_ISSUER || "",
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID || "",
  redirectUri: `${window.location.origin}/login/callback`,
  postLogoutRedirectUri: `${window.location.origin}/login`,
  pkce: true,
  scopes: ["openid", "email", "profile"],
};
